import { Button, Stack, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { IEmail } from "@/types/common";
import BaseDialog from "../../BaseDialog";

const ViewErrorDialogButton = ({ field }: { field: IEmail }) => {
  const [open, setOpen] = useState(false);
  return (
    <BaseDialog
      trigger={
        <p
          style={{
            color: "#E24F4B",
            cursor: "pointer",
          }}
        >
          Click to view
        </p>
      }
      title={"Email error text"}
      actionButtons={
        <Button variant="outline" onClick={() => setOpen(false)}>
          Close
        </Button>
      }
      open={open}
      setOpen={setOpen}
    >
      <Stack
        height={200}
        style={{
          marginTop: "30px",
        }}
      >
        <Text
          position="absolute"
          fontFamily="Lato"
          fontStyle="normal"
          fontWeight="400"
          fontSize="14px"
          lineHeight="160%"
          color="#323232"
        >
          {field?.submissions?.notes
            ? field?.submissions?.notes
            : "Unexcepted error"}
        </Text>
      </Stack>
    </BaseDialog>
  );
};

export default ViewErrorDialogButton;
